<template>
  <b-modal
    id="modal-produtos-adesao"
    size="md"
    @show="showModalProdutosAdesao"
    @hidden="resetModalProdutosAdesao"
    @ok="handleOkProdutosAdesao"
    ok-only
    ok-variant="warning"
    ok-title="Continuar"
  >
    <template v-slot:modal-title>
      {{ operadora.nome }}
    </template>
    <div class="text-center">
      <loader
          :width="'100px'"
          :height="'100px'"
          v-if="loadingProdutos" />
    </div>
    <div class="d-block text-center" v-if="produtosAdesao.length">
      <b-card no-body class="mb-1" v-for="(p, pindex) in produtosAdesao" :key="pindex">
          <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle="`accordion-${p.id}-${p.administradora.id}`"
                class="btn btn-link">
                  <div class="text-left mb-1">
                      {{ p.nome }} - {{ p.administradora.nome }}
                  </div>
              </b-button>
          </b-card-header>
          <b-collapse :id="`accordion-${p.id}-${p.administradora.id}`" accordion="cenarios-accordion" role="tabpanel">
              <b-card-body>
                  <div class="row">
                      <div class="col-12 col-xs-12 col-sm-6 col-md-4 text-left" v-for="e in p.entidades" :key="e.id">
                          <b-form-radio
                            :id="`entidade-${p.id}-${p.administradora.id}-${e.id}`"
                            v-model="adesao"
                            :name="`entidade-${p.id}-${p.administradora.id}-${e.id}`"
                            :value="`${p.id}#${p.administradora.id}#${e.id}`"
                            :state="stateAdesao">
                            {{ e.nome }}
                            <b-icon class="ml-1"
                              icon="exclamation-circle"
                              :id="`tooltip-target-${p.id}-${p.administradora.id}-${e.id}`"
                              :data-produto-id="p.id"
                              :data-administradora-id="p.administradora.id"
                              :data-entidade-id="e.id"></b-icon>

                            <b-tooltip :target="`tooltip-target-${p.id}-${p.administradora.id}-${e.id}`"
                              triggers="hover">
                              <div :inner-html.prop="tooltip"></div>
                            </b-tooltip>
                          </b-form-radio>
                      </div>
                  </div>
              </b-card-body>
          </b-collapse>
      </b-card>
    </div>
    <p class="text-center" v-else-if="!loadingProdutos">Nenhum produto encontrado</p>
  </b-modal>
</template>

<script>
import lodash from "lodash";
import { mapActions, mapGetters } from "vuex"
import Loader from "@/components/Loader";

export default {
  data() {
    return {
      adesao: null,
      produtoSelecionado: null,
      produtosAdesao: [],
      administradoraSelecionada: null,
      entidadeSelecionada: null,
      tooltip: 'Carregando ...',
    }
  },
  computed: {
    ...mapGetters("share", {
      filtros: "getFiltros"
    }),
    ...mapGetters("cenario", {
      cenario: "getCenario",
      cenarios: "getCenarios"
    }),
    ...mapGetters("produto", {
      produtos: "getProdutos",
      loadingProdutos: "getLoading"
    }),
    ...mapGetters("operadora", {
      operadora: "getOperadora",
      produto: "getProduto"
    }),
    ...mapGetters("entidade", {
      entidades: "getEntidades"
    }),
    stateAdesao() {
      return Boolean(this.adesao);
    },
    parseCompulorio() {
      return this.filtros.compulsorio == 2
        ? ""
        : this.filtros.compulsorio == 1
        ? "s"
        : "n"
    },
    parseCoparticipacao() {
      return this.filtros.coparticipacao == 2
        ? ""
        : this.filtros.coparticipacao == 1
        ? "s"
        : "n"
    },
    parseRegrasAceitacao() {
      return this.filtros.regras_aceitacao
        ? "s"
        : "n";
    },
    parseAcomodacao() {
      return this.filtros.acomodacao == 2
        ? ""
        : this.filtros.acomodacao == 1
        ? "a"
        : "e"
    },
    parseCredenciado() {
      return this.filtros.credenciado
        ? this.filtros.credenciado.tipo + this.filtros.credenciado.id
        : ""
    },
    parseProfissao() {
      return this.filtros.entidade_profissao?.tipo == 'p'
        ? this.filtros.entidade_profissao.value.id
        : ''
    },
    parseEntidade() {
      return this.filtros.entidade_profissao?.tipo == 'e'
        ? this.filtros.entidade_profissao.value.id
        : ''
    },
    parseMei() {
      return this.filtros.mei == 2
        ? ""
        : this.filtros.mei == 1
        ? "s"
        : "n"
    }
  },
  methods: {
    ...mapActions(
      "operadora",
      [
        "resetAdministradora",
        "resetEntidade",
        "selectedOperadora",
        "selectedProduto",
        "selectedAdministradora",
        "selectedEntidade"
      ]
    ),
    ...mapActions(
      "produto", [
        "resetProdutos",
        "buscaProduto"
      ]
    ),
    ...mapActions('entidade', ['buscaEntidades']),
    async resetModalProdutosAdesao() {
      await this.resetProdutos();
      await this.resetAdministradora();
      await this.resetEntidade();
    },
    async showModalProdutosAdesao() {
      this.produtoSelecionado = null
      this.produtosAdesao = []
      this.administradoraSelecionada = null
      this.entidadeSelecionada = null
      await this.buscaProduto({
        uf: this.filtros.cidade.uf,
        operadora: this.operadora.id,
        tipo_plano: this.filtros.tipo_plano,
        contratacao: this.filtros.contratacao,
        cidade: this.filtros.cidade ? this.filtros.cidade.id : "",
        compulsorio: this.parseCompulorio,
        coparticipacao: this.parseCoparticipacao,
        acomodacao: this.parseAcomodacao,
        regras_aceitacao: this.parseRegrasAceitacao,
        credenciado: this.parseCredenciado,
        entidade: this.parseEntidade,
        profissao: this.parseProfissao,
        faixas: this.cenario.faixas ? this.cenario.faixas : "",
        grupos_faixas: this.totalVidas(this.cenarios),
        mei: this.parseMei,
      })

      this.produtosAdesao = this.produtos.reduce((acc, obj) => {
        if (!Array.isArray(acc))
          acc = []
        let produtoId = obj.id
        let entidade = obj.entidade
        let administradoraId = obj.administradora.id
        let i = acc.findIndex(p => p.id === produtoId && p.administradora.id === administradoraId)
        if (i == -1) {
          acc.push({ id: obj.id, nome: obj.nome, administradora: obj.administradora, entidades: [entidade]})
        } else {
          acc[i].entidades.push(entidade)
          acc[i].entidades.sort((a, b) => a.nome > a.nome ? 1 : a.nome < b.nome  ? -1 : 0)
        }
        return acc
      }, {});
      if (this.produtosAdesao.length == 1) {
        if (this.produtosAdesao[0].entidades.length == 1) {
          this.produtoSelecionado = this.produtosAdesao[0]
          this.administradoraSelecionada = this.produto.administradora
          this.entidadeSelecionada = this.produto.entidades[0]
          this.selectedProduto(this.produtoSelecionado)
          this.selectedAdministradora(this.administradoraSelecionada)
          this.selectedEntidade(this.entidadeSelecionada)
          this.$bvModal.hide("modal-produtos-adesao");
          this.$bvModal.show("modal-produto-grupos");
        }
      }
    },
    totalVidas(cenarios) {
      var grupos_faixas = [];
      cenarios.forEach(cenario => {
        cenario.faixas.forEach(faixa => {
          let key = grupos_faixas.findIndex(gf => gf.slug == faixa.slug)
          if (key != -1) {
            grupos_faixas[key].value = parseInt(grupos_faixas[key].value||0) + parseInt(faixa.value||0);
          } else {
            grupos_faixas.push(JSON.parse(JSON.stringify(faixa)));
          }
        })
      });
      return grupos_faixas
    },
    handleOkProdutosAdesao(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmitProduto();
    },
    checkFormValidityProduto() {
      return this.adesao !== null;
    },
    handleSubmitProduto() {
      if (!this.checkFormValidityProduto()) {
        return;
      }
      let selected = this.adesao.split('#'),
          produtoId = selected[0],
          adminId = selected[1],
          entidadeId = selected[2]
      if (produtoId) {
        let produtos = this.produtosAdesao.filter(p => p.id == produtoId)
        let produto = produtos.find(p => p.administradora.id == adminId)
        this.produtoSelecionado = produto
        this.administradoraSelecionada = produto.administradora
        this.entidadeSelecionada = produto.entidades.find(e => e.id == entidadeId)
        this.selectedProduto(this.produtoSelecionado)
        this.selectedAdministradora(this.administradoraSelecionada)
        this.selectedEntidade(this.entidadeSelecionada)
        let operadora = this.operadora
        // operadora.administradora = this.administradoraSelecionada
        // operadora.entidade = this.entidadeSelecionada
        this.selectedOperadora(operadora)
        this.$nextTick(() => {
          this.$bvModal.hide('modal-produtos-adesao')
          this.$bvModal.show('modal-produto-grupos')
        })
      }
    },
  },
  mounted() {
    this.$nextTick(function () {
      let vm = this
      this.$root
        .$off('bv::tooltip::show')
        .$on('bv::tooltip::show', async bvEvent => {
          let target  = bvEvent.target,
              entidadeId = target.dataset.entidadeId

          vm.tooltip = '<span aria-hidden="true" class="spinner-border text-success"></span>'
          await vm.buscaEntidades({
            uf: vm.filtros.cidade.uf,
            entidadeId
          })
          vm.tooltip = '<ul style="font-size:12px; text-align:left;">'
          vm.tooltip += vm.entidades.profissoes.slice(0, 9).map(p => '<li><b>' + p.nome + '</b></li>').join('')
          if (vm.entidades.profissoes.length > 10) {
            vm.tooltip += '<li><b>e outras ' + (vm.entidades.profissoes.length - 10) + ' profissões </b></li>'
          }
          vm.tooltip += '</ul>'
        })
    })
  },
  components: {
    Loader
  }
}
</script>

<style>

</style>
